export default "/_next/static/images/325294d9f3c77b2861a1f433ec0032fc.png";